import { render, staticRenderFns } from "./BackTop.vue?vue&type=template&id=d1c72afc&scoped=true&"
import script from "./BackTop.vue?vue&type=script&lang=js&"
export * from "./BackTop.vue?vue&type=script&lang=js&"
import style0 from "./BackTop.vue?vue&type=style&index=0&id=d1c72afc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c72afc",
  null
  
)

export default component.exports